import React, { ReactNode } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "components/shadcn/accordion";
import { Translate } from "components/common/Translate/Translate";
import LinkRenderer from "components/common/LinkRenderer/LinkRenderer";

export interface IFaq {
    question: string;
    answer: string;
}

export interface IFaqProps {
    faqAsList: IFaq[];
    sectionTitle: string | ReactNode;
    sectionSubTitle: string | ReactNode;
    variables?: Record<any, any>;
}

export const FAQScaffold = ({ faqAsList, sectionTitle, sectionSubTitle, variables }: IFaqProps) => {
    return (
        <div className="compress-jpeg-faq-saction mt-24 md:mt-[150px] flex flex-col dark:text-white">
            <div className="text-center">
                <h2 className="text-24 font-semibold">{sectionTitle}</h2>
                <p className="mt-2">{sectionSubTitle}</p>
            </div>

            <div className="mt-10">
                {faqAsList.map((e, index) => {
                    const questionText = `${index + 1}. ${e.question}`;
                    return (
                        <Accordion type="single" collapsible key={e.question} className="mt-8">
                            <AccordionItem
                                value={e.question}
                                className={`pb-7 ${faqAsList.length === index + 1 && "border-0"}`}
                            >
                                <AccordionTrigger className="hover:no-underline items-start">
                                    <div className="text-xl font-semibold text-start">
                                        {`${index + 1}. `} <Translate keyName={e.question} variables={variables} />
                                    </div>
                                </AccordionTrigger>
                                <AccordionContent className="pb-1">
                                    <h3 className="text-xl font-semibold hidden">
                                        {`${index + 1}. `} <Translate keyName={e.question} variables={variables} />
                                    </h3>
                                    <p className="pt-2 text-base">
                                        <Translate
                                            keyName={e.answer}
                                            variables={variables}
                                            linkRenderer={(label, linkKey) => {
                                                return <LinkRenderer label={label} linkKey={linkKey} />;
                                            }}
                                        />
                                    </p>
                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>
                    );
                })}
            </div>
        </div>
    );
};